import { PreparedServerCard, Card } from '../types';
import { checkIsVirtualCard } from './checkIsVirtualCard';

export const getAllowedSavedCardsByActiveCard = (
  activeCard: Card,
  cards: PreparedServerCard[]
): PreparedServerCard[] => {
  const isSelectedCardVirtual = checkIsVirtualCard(activeCard, cards);

  return cards.filter((card) => Boolean(card.isOTTCard) === isSelectedCardVirtual);
};
